export default __webpack_public_path__ + "static/media/certifiedIcon.572bb33b.svg";